export default __webpack_public_path__ + "static/media/regulatory--bicycle-lane-left--g1.4ca4b400.png";